export enum modalTypes {
  add_to_collection = 'add_to_collection',
  alert = 'alert',
  banner_video = 'banner_video',
  collection_filters = 'collection_filters',
  content_details = 'content_details',
  content_suggestion = 'content_suggestion',
  create_collection_folder = 'create_collection_folder',
  delete_account = 'delete_account',
  delete_collection = 'delete_collection',
  edit_avatar = 'edit_avatar',
  edit_data = 'edit_data',
  edit_guardian_data = 'edit_guardian_data',
  edit_language = 'edit_language',
  edit_password = 'edit_password',
  move_collection = 'move_collection',
  move_collection_drop = 'move_collection_drop',
  new_content = 'new_content',
  rename_collection = 'rename_collection',
  share_collection = 'share_collection',
  viewer_help = 'viewer_help'
}
